import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Spinner, Row, Col, Card } from 'react-bootstrap';
import { QRCodeCanvas } from 'qrcode.react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTabletAlt, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import config from '../../config';

const ContratoAssinaturaModal = ({ show, onHide, codigo, agendamentoId, onSigned }) => {
    const [isChecking, setIsChecking] = useState(false);
    const [error, setError] = useState(null);
    const pollingInterval = useRef(null);

    // URL que o tablet irá acessar (ajuste conforme sua rota de assinatura pública)
    const signatureUrl = `${window.location.origin}/assinar/${codigo}`;

    const checkStatus = async () => {
        if (!codigo) return;

        try {
            // Backend deve ter um endpoint que retorna o status do contrato pelo código
            const response = await axios.get(`/api/contratos/status/${codigo}`);
            
            if (response.data.status === 'assinado') {
                onSigned(); // Notifica o PaymentModal
                stopPolling();
            }
        } catch (err) {
            console.error("Erro ao verificar status da assinatura:", err);
            // Não paramos o polling por erro de rede temporário, apenas logamos.
        }
    };

    const startPolling = () => {
        stopPolling();
        setIsChecking(true);
        // Verifica a cada 3 segundos
        pollingInterval.current = setInterval(checkStatus, 3000);
    };

    const stopPolling = () => {
        if (pollingInterval.current) {
            clearInterval(pollingInterval.current);
            pollingInterval.current = null;
        }
        setIsChecking(false);
    };

    useEffect(() => {
        if (show && codigo) {
            startPolling();
        } else {
            stopPolling();
        }
        return () => stopPolling();
    }, [show, codigo]);

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    <FontAwesomeIcon icon={faTabletAlt} className="me-2 text-primary" />
                    Assinatura no Tablet
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center p-4">
                <p className="mb-4">Peça ao paciente para ler o QR Code ou digitar o código no tablet de atendimento.</p>

                <Card className="mb-4 border-primary bg-light">
                    <Card.Body>
                        <h6 className="text-muted text-uppercase mb-2">Código de Acesso</h6>
                        <h2 className="display-4 fw-bold text-primary mb-0" style={{ letterSpacing: '5px' }}>
                            {codigo}
                        </h2>
                    </Card.Body>
                </Card>

                <div className="d-flex flex-column align-items-center mb-4">
                    <div className="p-3 bg-white border rounded shadow-sm mb-3">
                        <QRCodeCanvas 
                            value={signatureUrl} 
                            size={180}
                            level={"H"}
                            includeMargin={true}
                        />
                    </div>
                    <small className="text-muted">Aponte a câmera do tablet para o QR Code acima</small>
                </div>

                <hr />

                <div className="d-flex justify-content-center align-items-center text-primary mt-3">
                    {isChecking ? (
                        <>
                            <Spinner animation="grow" size="sm" className="me-2" />
                            <span className="fw-bold">Aguardando assinatura do paciente...</span>
                        </>
                    ) : (
                        <span className="text-success">
                            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                            Assinatura detectada!
                        </span>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar e fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ContratoAssinaturaModal;
